import React, { PureComponent } from 'react'
import {
  func, shape, bool, instanceOf, string
} from 'prop-types'
import Button from '@active/react-ui/Button'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import Link from '@active/react-ui/Link'
import { withI18n } from '@active/react-utils/i18n'

import Form from '../common/InjectedForm'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import I18nMessage from '../common/I18nMessage'
import CreateAccountDetail from './components/CreateAccount'
import CreatedAccount from './components/CreatedAccount'
import { FacebookCreateAccount, FacebookBindAccount } from '../common/Facebook'
import CoppaEmailInput from '../common/CoppaEmailInput'
import { omit, filterDate } from '../../shared/utils/commonUtils'
import CheckEmail from '../common/CheckEmail/CheckEmail'
import withKeycloak from '../../shared/utils/withKeycloak'
import { noop,merge } from '../../shared/utils/commonUtils'

import './Signup.scss'
import connectLocale from '../../shared/utils/connectLocale'

class Signup extends PureComponent {
  static propTypes = {
    processes: shape({
      signIn: func.isRequired,
      signUp: func.isRequired,
    }).isRequired,
    actions: shape({
      signupSuccessCallback: func,
    }),
    services: shape({
      checkAccount: func.isRequired,
    }).isRequired,
    clientConfig: shape({
      disableSignInLink: bool,
    }).isRequired,
    configureTrack: func.isRequired,
    Header: func,
    initKeycloak: func,
    authWithKeycloak: bool,
    onKeycloakSubmit: func,
    dobField: shape({
      hidden: bool, value: instanceOf(Date), optional: bool, customerValidator: func,
    }),
    initError: string,
    onKeycloakSubmit: func,

  }

  static defaultProps = {
    Header: null,
    actions: {},
    dobField: {},
    initKeycloak: noop,
    authWithKeycloak: false,
    onKeycloakSubmit: null,
    initError: null,
    onKeycloakSubmit: noop,
  }

  checkEmail

  constructor(props) {
    super(props)

    this.state = {
      coppaEmailResult: {},
    }
  }

  componentDidMount() {
    const { configureTrack,initKeycloak } = this.props
    configureTrack({
      eventName: 'CreateAccount',
      widget: 'create_account',
      pageType: 'create account',
    })
    initKeycloak(() => {})
  }


  setSwitchConfig = newState => {
    this.setState({
      createAccountConfig: null,
      createdAccountSuccessConfig: null,
      facebookCreateAccountConfig: null,
      facebookBindAccountConfig: null,
      ...newState,
    })
  }

  checkEmailTrigger = checkEmail => {
    this.checkEmail = checkEmail
  }

  handleSubmit = values => {
    this.checkEmail(values.account, this.checkEmailCallback)
  }

  checkEmailCallback = ({ existAccount, newAccount, badDomain }) => {
    const { actions: { signupSuccessCallback } } = this.props
    if (existAccount) {
      this.goSignin({
        username: existAccount,
        existingAccount: true,
      })
    } else if (newAccount) {
      this.setSwitchConfig({
        createAccountConfig: {
          enableCoppaFlow: true,
          hideCollectingConsents: false,
          hasSubmitButton: true,
          hasSignInLink: true,
          hasSignupTitle: true,
          hasDefaultCreateHandle: true,
          fields: {
            email: newAccount,
          },
          onCreateAccountSuccess: createdAccountSuccessConfig => {
            if (signupSuccessCallback) {
              signupSuccessCallback(createdAccountSuccessConfig)
            } else {
              this.setSwitchConfig({ createdAccountSuccessConfig })
            }
          },
        },
      })
    } else if (badDomain) {
      this.setState({
        isShowEmailBadListTip: true,
      })
    }
  }
  
  handleCheckAccount = ({params, resolve})  => {
      const {locale, authType, countriesInfo: countryCodes, onKeycloakSubmit,  clientConfig: { suppressActiveWaiver, useCustomizeWaiver, waiverAttachementObjectIds }} = this.props
        const data = {
        username: params.email,
        locale,
        authType,
        countriesInfo: countryCodes,
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      }
      onKeycloakSubmit(data).then(result => resolve(result))
  }

  goSignin = ({ username, existingAccount }) => {
    const { processes: { signIn, signUp: goBack } } = this.props

    signIn({
      goBack,
      username,
      existingAccount,
      sentEmailGoBack: goBack,
      goSignUp: '',
    })
  }

  render() {
    const {
      clientConfig: { disableSignInLink },
      services, Header,authWithKeycloak, onKeycloakSubmit,
      // dobField for init Date
      dobField,
      initError,
    } = this.props
    const {
      createAccountConfig,
      createdAccountSuccessConfig,
      facebookCreateAccountConfig,
      facebookBindAccountConfig,
      coppaEmailResult,
      isShowEmailBadListTip,
    } = this.state

    if (coppaEmailResult.showCoppaEmailInput) {
      return (
        <CoppaEmailInput Header={Header} {...coppaEmailResult} {...this.props} />
      )
    }

    if (createAccountConfig) {
      const initDob = filterDate(dobField.value) || new Date()
      return (
        <CreateAccountDetail
          {...createAccountConfig}
          {...omit(this.props, ['fields'])}
            // Extract init dob from Component to Widget
          dobField={({ ...dobField, value: initDob })}
            // USER-5726 Do not support amEighteen except CUISingup
          amEighteen={false}
          authWithKeycloak={authWithKeycloak}
          onKeycloakSubmit={onKeycloakSubmit}
        />
      )
    }
    if (createdAccountSuccessConfig) {
      return (
        <CreatedAccount {...this.props} {...createdAccountSuccessConfig} />
      )
    } if (facebookCreateAccountConfig) {
      return (
        <FacebookCreateAccount {...facebookCreateAccountConfig} {...this.props} />
      )
    } if (facebookBindAccountConfig) {
      return (
        <FacebookBindAccount
          handleReturn={() => this.setState({ facebookBindAccountConfig: null })}
          {...facebookBindAccountConfig}
          {...this.props}
        />
      )
    }

    return (
      <DefaultComponentLayout nameSpace="passport__signup" Header={Header} errMsg={initError}>
        <LayoutContent title message="passport.signup.title" />
        <LayoutContent main>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup name="account" required withoutLayout className="check-email-form-group" hideAsterisk>
              <FormLabel htmlFor="account"><I18nMessage id="passport.common.label.emailAddress" /></FormLabel>
              <FormField
                as={CheckEmail}
                changeAble
                services={services}
                checkEmailTrigger={this.checkEmailTrigger}
                requiredError="passport.error.validation.invalidEmail"
                invalidError="passport.error.validation.invalidEmail"
                enableDomainCheck
                tipContent="passport.common.text.typoTip.content.withRegist"
                isShowWarning={isShowEmailBadListTip}
                handleCheckAccount = {authWithKeycloak ? this.handleCheckAccount : undefined}
              />
            </FormGroup>
            <Button submit type="super" className="passport__signup__button">
              <I18nMessage id="passport.common.btn.next" />
            </Button>
          </Form>
          {!disableSignInLink && (
          <div className="passport__form__subtitle passport__signup__signin">
            <I18nMessage id="passport.signup.notice.haveAccount" />
            <Link
              tabIndex={0}
              onClick={this.goSignin}
              className="passport__pl5"
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  this.goSignin({})
                }
              }}
            >
              <I18nMessage id="passport.common.btn.signIn" />
            </Link>
          </div>
          )}
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default withI18n(connectLocale(withKeycloak(Signup, 'Signup')))
